<template lang="pug">
  b-modal#table-list-modal.modal-list(
    size="xl",
    v-model="show",
    header-class="lmm-table-list-modal-header",
    @hide="close"
    hide-footer
    )
    template(slot="modal-header")
      img(src="../../assets/main_logo-white.svg" style="height: 20px")
      b-button.close-btn(
        variant="danger"
        size="sm",
        @click="close"
      ) X
    b-container(fluid)
      div(slot="header")
        b-row
          b-col(cols="9")
            b-input-group.mx-1.w-100(size="sm")
              template(slot="prepend")
                b-dropdown(:text="$t(search.key.text)", size="sm", variant="grey-200")
                  b-dropdown-item(
                    v-for="opt in search.options",
                    :key="opt.value",
                    @click="setSearchKey(opt)") {{$t(opt.text)}}
              b-form-input(v-model="search.value", @keypress.enter="searchHandler" style="width: 10%")
              b-input-group-append.ml-2
                b-btn(@click="searchHandler" variant="secondary") {{$t('search')}}
      b-card.table-card.mt-3
        b-table(
          ref="managersListView",
          :fields="fields",
          :items="managersList",
          :current-page="page.current",
          :per-page="page.per",
          :empty-text="$t('no-content')",
          tbody-class="lmm-table-body",
          sort-by="mgrid",
          :sort-desc="false",
          show-empty,
          hover
        )
          template(v-slot:cell(add)="row")
            b-button(size="sm", @click="rowClickHandler(row.item)")
              icon(name="plus")

      div.d-flex.justify-content-between.mt-2
        div
          b-form-select(
            size="sm",
            v-model="page.per",
            :options="page.perOptions")
        b-pagination(
          size="sm",
          :total-rows="page.total",
          :per-page="page.per",
          v-model="page.current",
          class="my-0 float-right"
        )
</template>

<script>
import _ from "lodash";
import Users from "@/api/users";
import {ApprovalsAPI, ConnDeviceGroupAPI, DeviceGroupAPI, UsersAPI} from "@/api";
import store from '@/api/store'

const defaultValues = {
  size: 'lx',
  title: '',
  context: '',
  headerBgVariant: 'light',
  headerTextVariant: 'dark',
  bodyBgVariant: 'light',
  bodyTextVariant: 'dark',
  footerBgVariant: 'light',
  footerTextVariant: 'dark',
  align: 'center'
}

export default {
  name: 'list-modal-dialog',
  methods: {
    close () {
      this.show = false
      setTimeout(() => {
        this.page.current = 1
        this.search.value = ''
      },300)
    },
    searchHandler () {
      this.$refs.managersListView.refresh()
    },
    setSearchKey (opt) {
      this.search.value = null
      this.search.key = opt
    },
    managersList (ctx) {
      this.pageMounted = false
      let params = {
        by: ctx.sortBy,
        flag_servant: true,
        limit: ctx.perPage,
        offset: (ctx.currentPage - 1) * ctx.perPage,
        order: ctx.sortDesc ? 'desc' : 'asc',
        search_mode: 'pagination',
        context: this.context.path,
      }

      if (params.context === 'group_users_list_modal') {
        params.groupPk = this.groupData.pk
      }

      if (this.search.value) {
        params.search_key = this.search.key.value
        params.search_value = this.search.value
      }

      return Users.get('', {params})
          .then(resp => {
            setTimeout(() => {
              this.pageMounted = true
            }, 300)
            this.page.total = resp.data.meta.total_count
            resp.data.objects.map((item) => {
              if (item.member_type_id === 1) {
                item.member_type_id = this.$t('department-members')
              } else if (item.member_type_id === 2) {
                item.member_type_id = this.$t('admin')
              } else {
                item.member_type_id = this.$t('middle-managers')
              }
            })
            return resp.data.objects
          }).catch(err => {
            console.log(err)
          })
    },
    rowClickHandler(e) {
      if (this.context.path === 'middle_manager_list_modal') {
        this.changeMiddleManager(e);
      }
      else if (this.context.path === 'group_users_list_modal') {
        this.addUserFromGroup(e)
      }
      else if (this.context.path === 'add_manager') {
        this.selectedMiddleManager(e);
      }
    },
    async changeMiddleManager(e) {
      // e는 누른 대상. 즉 내가 상위 부서장으로 삼고 싶은 사람.
      let params = {
        name: e.mgrid
      }
      // resp 또한 누른 대상에 대한 정보이다.
      const resp = await ApprovalsAPI.get('search', {params})
      if (resp.data.status === 200) {
        let params = {
          approver_fk: resp.data.objects[0].pk,
          user_type: this.userType,
        }

        this.managedUser.mgrid = resp.data.objects[0].mgrid
        this.managedUser.name = resp.data.objects[0].name

        UsersAPI.put(`${this.userPk}`, params)
            .then(resp => {
              this.AppState.$emit('send-department-head-data', this.managedUser)
              this.close()
            })
      } else {
        let params = {
          context: {path: 'search_manager_405'},
          withoutInput: true,
          withoutCancel: true,
          submit: {
            size: 'sm',
            color: 'danger',
            text: 'submit'
          }
        }
        this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
          if (key === 'submit') {
            this.$router.go(this.$router.currentRoute)
          }
        })
      }
    },
    async addUserFromGroup (e) {
      let params = {
        name: e.mgrid,
        member_fk: e.pk,
        device_group_fk: this.groupData.pk,
      }

      ConnDeviceGroupAPI.post('', params)
          .then(resp => {
            this.AppState.$emit('send-group-user-data')
            DeviceGroupAPI.get('').then(resp => {
              this.groupList = resp.data.objects
              let index = _.findIndex(this.groupList, {pk: this.groupData.pk})
              store.update('devices', ({groups}) => {
                let storeIndex = _.findIndex(groups, {pk: this.groupData.pk})
                groups[storeIndex].users = this.groupList[index].users
                this.$awn.success(this.$t('user_in_group_add_success'))
                this.$refs.managersListView.refresh()
                // this.$router.go(this.$router.currentRoute)
              })
            })
          })
    },
    async selectedMiddleManager (e) {
      if (e.member_type_id === '부서원') {
        let params = {
          context: {path: 'search_manager_405'},
          withoutInput: true,
          withoutCancel: true,
          submit: {
            size: 'sm',
            color: 'danger',
            text: 'submit'
          }
        }
        this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
          if (key === 'submit') {
            this.$router.go(this.$router.currentRoute)
          }
        })
      }
      else {
        let params = {
          id: e.mgrid,
          name: e.name,
          pk: e.pk,
          selectedManager: true
        }

        this.AppState.$emit('send-department-head-data', params)
        this.close()
      }
    },
  },
  created () {
    this.dialog = defaultValues
    this.AppState.$on('show-list-modal-dialog', data => {
      this.dialog = _.assign(this.dialog, data)
      this.show = true
      this.userPk = data.userPk
      this.userType = data.userType
      this.context = data.context
      this.groupData = data.groupData
      this.userList = data.userList
    })
  },
  data() {
    return {
      show: false,
      managedUser: {},
      dialog: {},
      pageMounted: false,
      userPk: null,
      userType: null,
      context: null,
      groupData: null,
      userList: null,
      fields: [
        { key: 'name', label: this.$t('name'), sortable: false },
        { key: 'mgrid', label: this.$t('ID'), sortable: false },
        { key: 'member_type_id', label: this.$t('permission'), sortable: false },
        { key: 'add', label: this.$t('add'), thClass: 'text-center', tdClass: 'text-center'
        }
      ],
      page: {
        total: 0,
        current: 1,
        per: 10,
        perOptions: [
          { value: 5, text: '5' },
          { value: 10, text: '10' },
          { value: 15, text: '15' },
          { value: 20, text: '20' }
        ]
      },
      search: {
        key: { value: 'name', text: 'name' },
        options: [
          { value: 'name', text: 'name' },
          { value: 'mgrid', text: 'user' },
          { value: 'department', text: 'department'},
          { value: 'authority', text: 'permission' }
        ],
        value: null
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./dialogs.scss"></style>

<style lang='scss' scoped>
::v-deep .modal-header {
  align-items: center !important;
}
</style>